const PRINTER_URL = "http://127.0.0.1:8080/imprimir"

export interface PrinterPayload {
  nombre: string
  puesto: string
  empresa: string
  folio: string
}

export interface PrinterResult {
  ok: boolean
  message: string
}

export async function sendToPrinter(payload: PrinterPayload): Promise<PrinterResult> {
  console.log("[printer] sendToPrinter llamado →", PRINTER_URL, payload)
  try {
    const res = await fetch(PRINTER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(15000),
    })

    let data: any
    try {
      data = await res.json()
    } catch {
      console.error("[printer] respuesta sin payload JSON válido →", res.status)
      return { ok: false, message: "Error de comunicación con la impresora" }
    }

    console.log("[printer] respuesta →", res.status, data)

    if (!res.ok || data?.status === "error") {
      return { ok: false, message: data?.message ?? "Error desconocido en impresora" }
    }

    return { ok: true, message: data?.message ?? "Impresión exitosa" }
  } catch (err) {
    // El detalle técnico ("Failed to fetch", timeout…) queda en consola; en pantalla, un mensaje para el asistente
    console.error("[printer] error →", err)
    return { ok: false, message: friendlyConnectionError(err) }
  }
}

function friendlyConnectionError(err: unknown): string {
  // AbortSignal.timeout → DOMException "TimeoutError"
  if (err instanceof DOMException && err.name === "TimeoutError") {
    return "La impresora no respondió a tiempo. Pide apoyo al personal del evento."
  }
  // fetch rechaza con TypeError si el servicio no está encendido o el navegador bloquea la conexión local
  return "No se pudo conectar con la impresora. Pide apoyo al personal del evento."
}
